// SVGs to be moved to S3 and imported from there.
import { ReactComponent as UpcomingTaxDeadline } from './images/UpcomingTaxDeadlineAlert.svg'
import { ReactComponent as UpcomingTaxDeadlineCIBC } from './images/UpcomingTaxDeadlineAlertCIBC.svg'

import { ReactComponent as FederalBankHoliday } from './images/FederalBankHoliday.svg'
import { ReactComponent as FederalBankHolidayCIBC } from './images/FederalBankHolidayCibc.svg'

import { ReactComponent as DesignateEmergencySavingsAccount } from './images/DesignateEmergencySavingsAccount.svg'

export const getLayoutConfig = (variant: string | null, isCibc: boolean = false) => {
  const config = {
    Holiday: {
      image: isCibc ? FederalBankHolidayCIBC : FederalBankHoliday,
    },
    Reminder: {
      image: isCibc ? UpcomingTaxDeadlineCIBC : UpcomingTaxDeadline,
    },
    Savings: {
      image: DesignateEmergencySavingsAccount,
    },
  }
  return config[variant as keyof typeof config]
}
